import { render, staticRenderFns } from "./HomeHelp.vue?vue&type=template&id=22f8f6d6&scoped=true"
import script from "./HomeHelp.vue?vue&type=script&lang=js"
export * from "./HomeHelp.vue?vue&type=script&lang=js"
import style0 from "./HomeHelp.vue?vue&type=style&index=0&id=22f8f6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f8f6d6",
  null
  
)

export default component.exports